export const LOGIN = '/login';
export const CHOOSE_CONSOLE = '/choose-console'
export const RESET_PASSWORD = '/reset-password';
export const NEW_PASSWORD = '/new-password';
